import type { StopTimeData } from '@/@types/gtfs-ressource';

export enum StopEmptyState {
  NO_SERVICE_TODAY = 'noServiceToday',
  /** Buses end their trip here, none leaves from it. */
  ARRIVALS_ONLY = 'arrivalsOnly',
  END_OF_SERVICE = 'endOfService',
}

/**
 * Last departure of the day from the stop, as an absolute timestamp in seconds.
 * A trip's last stop is not a departure. `undefined` when no trip leaves from the stop.
 */
export function getLastDepartureTs(stopTimesOfDay: StopTimeData[]): number | undefined {
  let lastDepartureTs: number | undefined;
  stopTimesOfDay.forEach(st => {
    if (st.last_stop) return;
    const departureTs = st.estimated_departure_ts ?? st.departure_ts;
    if (lastDepartureTs === undefined || departureTs > lastDepartureTs) lastDepartureTs = departureTs;
  });
  return lastDepartureTs;
}

/**
 * Message shown in place of an empty departure list. `undefined` while departures are
 * still ahead: the list is then only empty for a moment, e.g. a vehicle running early.
 */
export function getStopEmptyState(
  stopTimesOfDay: StopTimeData[],
  lastDepartureTs: number | undefined,
  nowTs: number,
): StopEmptyState | undefined {
  if (stopTimesOfDay.length === 0) return StopEmptyState.NO_SERVICE_TODAY;
  if (lastDepartureTs === undefined) return StopEmptyState.ARRIVALS_ONLY;
  if (lastDepartureTs < nowTs) return StopEmptyState.END_OF_SERVICE;
  return undefined;
}
